import axios from 'axios';
import { API } from '../config/api';
// import { v4 as uuidv4 } from 'uuid';

// Create axios instance with default config
const axiosInstance = axios.create({
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

// Helper function to generate request ID
// const generateRequestId = () => uuidv4();

// Helper function to get headers with request ID
// const getHeaders = () => ({
//   'x-request-id': generateRequestId(),
// });

// History API functions
export const historyService = {
  // Create new history record
  createHistory: async (data: any) => {
    const response = await axiosInstance.post(API.HISTORY.create, data, {
      // headers: getHeaders(),
    });
    return response.data;
  },

  // Get all history records
  getAllHistory: async () => {
    const response = await axiosInstance.get(API.HISTORY.getAll, {
      // headers: getHeaders(),
    });
    return response.data;
  },

  // Get paginated history records
  getPaginatedHistory: async (params: {
    page: number;
    limit: number;
    sortColumn?: string;
    sortOrder?: 'asc' | 'desc';
  }) => {
    const response = await axiosInstance.get(API.HISTORY.paginate, {
      params,
      // headers: getHeaders(),
    });
    return response.data;
  },

  // Search history records
  searchHistory: async (term: string) => {
    const response = await axiosInstance.get(API.HISTORY.search, {
      params: { term },
      // headers: getHeaders(),
    });
    return response.data;
  },

  getById: async (id: string) => {
    const response = await axiosInstance.get(API.HISTORY.getById(id), {
      // headers: getHeaders(),
      withCredentials: true,
    });
    return response.data;
  },

  // Update file label
  updateFileLabel: async (id: string, data: any) => {
    const response = await axiosInstance.patch(API.HISTORY.patch.fileLabel(id), data, {
      // headers: getHeaders(),
      withCredentials: true,
    });
    return response.data;
  },

  // Delete history record
  deleteHistory: async (id: string) => {
    const response = await axiosInstance.delete(API.HISTORY.delete(id), {
      // headers: getHeaders(),
      withCredentials: true,
    });
    return response.data;
  },

  // // Update history record
  // updateHistory: async (id: string, data: any) => {
  //   const response = await axiosInstance.put(API.HISTORY.update(id), data, {
  //     // headers: getHeaders(),
  //     withCredentials: true,
  //   });
  //   return response.data;
  // },

  // // Update validation complete status
  // updateValidationComplete: async (id: string, data: any) => {
  //   const response = await axiosInstance.patch(API.HISTORY.patch.validationComplete(id), data, {
  //     // headers: getHeaders(),
  //     withCredentials: true,
  //   });
  //   return response.data;
  // },

  // // Update JSON timestamp
  // updateJsonTimestamp: async (id: string, data: any) => {
  //   const response = await axiosInstance.patch(API.HISTORY.patch.jsonTimestamp(id), data, {
  //     // headers: getHeaders(),
  //     withCredentials: true,
  //   });
  //   return response.data;
  // },

  // // Cancel history record
  // updateCancelled: async (id: string, data: any) => {
  //   const response = await axiosInstance.patch(API.HISTORY.patch.cancel(id), data, {
  //     // headers: getHeaders(),
  //     withCredentials: true,
  //   });
  //   return response.data;
  // },

  // // Update token information
  // updateToken: async (id: string, data: any) => {
  //   const response = await axiosInstance.patch(API.HISTORY.patch.token(id), data, {
  //     // headers: getHeaders(),
  //     withCredentials: true,
  //   });
  //   return response.data;
  // },

  // Update invalid status
  // updateInvalid: async (id: string, data: any) => {
  //   const response = await axiosInstance.patch(API.HISTORY.patch.invalid(id), data, {
  //     // headers: getHeaders(),
  //     withCredentials: true,
  //   });
  //   return response.data;
  // },
};
